module.exports = __webpack_public_path__ + "static/media/wheelOut.6a0efaa0.png";